/*
* @描述: 订单重新提交
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025-02-25 19:09:14
*/
<template>
    <div>
        <el-dialog :before-close="handleDialogClose"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :modal-append-to-body="false"
                   :visible.sync="dialogVisible"
                   class="custom_form_dialog custom-form-dialog"
                   title="新建订单"
                   width="1000px">
            <div v-loading="loading" class="custom_form_body">
                <CustomFormPc v-if="dataLoaded&&formInfoList.length"
                              ref="orderForm"
                              :field_form="'orders'"
                              :field_list="formInfoList"
                              :form_detail="orderFormData"
                              :is_form_module="true"
                              :pk_id="order_id?order_id:project_quotation_id"
                              :is_recalculate="true"
                              @submit-form="submitOrderFormData"/>
                <div v-if="isApproval===1" class="add_approval_select_process">
                    <div class="page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <approveProcessSelect ref="approveProcessSelectRef"
                                          :approval_node_list="approval_node_list">
                    </approveProcessSelect>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button :disabled="btnDisabled||loading" plain type="primary" @click="handleDialogSave">保存
                </el-button>
                <el-button :disabled="btnDisabled||loading" type="primary" @click="handleDialogConfirm">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import {
    getFormFields,
    orderAdd,
    getApprovalNodes,
    orderReSubmitDetail,
    orderImportDetails,
} from "@/api";
import {getBusinessIsApproval} from "@/utils";
import {pagination} from "@/mixins";

export default {
    name: "OrderSubmitAgain",
    data() {
        return {
            formInfoList: [],
            orderFormData: {
                project_quotation_id: ''
            },
            isApproval: 0,
            is_release: 1,
            importQuotationVisible: false,
            searchForm: {
                keyword: '',
            },
            defaultImg: require('@/assets/images/default.jpg'),
            approval_node_list: [],
            dataLoaded: false,
            btnDisabled: false,
            loading: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0,
        },
        project_quotation_id: {
            type: Number,
            default: 0,
        },
    },
    components: {CustomFormPc, approveProcessSelect},
    created() {
        this._getFromFields()
    },
    mixins: [pagination],
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'orders'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    if (this.order_id) {
                        this.getOrderDetail()
                    }
                    if (this.project_quotation_id) {
                        this.getQuotationDetail()
                    }
                    getBusinessIsApproval('order_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'order_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                } else {

                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                } else {

                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        getOrderDetail() {
            orderReSubmitDetail({
                order_id: this.order_id
            }).then(res => {
                this.orderFormData = res.data
                const order_goods = res.data.order_goods.filter(good => good.goods_status !== 0 && !good.goods_deleted_at)
                this.recalculateTheTotalCost(order_goods)
                this.orderFormData.order_goods = order_goods
                this.dataLoaded = true
            })
        },

        getQuotationDetail() {
            orderImportDetails({
                project_quotation_id: this.project_quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderFormData.project_id = res.data.project_id
                    this.orderFormData.customer_id = res.data.customer_id
                    this.orderFormData.contact_id = res.data.contact_id
                    this.orderFormData.salesperson = res.data.salesperson
                    this.orderFormData.project_quotation_id = res.data.project_quotation_id
                    const order_goods = res.data.order_goods
                    this.recalculateTheTotalCost(order_goods)
                    this.orderFormData.order_goods = order_goods
                    this.dataLoaded = true
                } else {

                }
                this.loading = false
            })
        },

        recalculateTheTotalCost(order_goods) {
            order_goods.forEach(goods => {
                if (goods.goods_type === 'bundle') {
                    goods._child.forEach(child => {
                        child.cost_price = Number(child.goods_cost_price)
                        child.guide_price = child.type === 1 ? Number(child.sale_guide_price) : Number(child.lease_guide_price)
                        child.is_virtual = child.can_in_out_stock
                    })
                    goods.cost_price = goods._child.reduce((total, child) => {
                        return total + child.cost_price
                    }, 0).toFixed(2)
                    goods.guide_price = goods._child.reduce((total, child) => {
                        return total + child.guide_price
                    }, 0).toFixed(2)
                    goods.is_virtual = goods._child.some(child => child.can_in_out_stock === 1) ? 1 : 0
                } else {
                    goods.cost_price = Number(goods.goods_cost_price).toFixed(2)
                    goods.guide_price = goods.type === 1 ? Number(goods.sale_guide_price).toFixed(2) : Number(goods.lease_guide_price).toFixed(2)
                    goods.is_virtual = goods.can_in_out_stock
                }
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取订单表单数据
        submitOrderFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.btnDisabled = true
            const formData = {
                ...data,
                is_release: this.is_release,
                node_list: this.approval_node_list,
                project_quotation_id: this.orderFormData.project_quotation_id,
                goods_cost_price: data.order_goods.reduce((total, item) => {
                    // 只处理 type 为 1 的商品
                    if (item.type === 1) {
                        // 计算价格
                        return total + (item.cost_price ? item.cost_price * item.num : 0);
                    }
                    return total; // 如果不满足条件，保持总值不变
                }, 0)
            }
            orderAdd(formData).then(res => {
                if (res.code === 200) {
                    this.$message.success(this.is_release === 0 ? '保存成功' : '新增成功')
                    this.$emit('refresh-list')
                    this.handleDialogClose()
                } else {
                    this.btnDisabled = false
                }
            })
        },

        //保存
        handleDialogSave() {
            this.is_release = 0
            this.$refs.orderForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.orderForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_body {
    height: 677px;
    padding: 24px;
}

.import_quotation_wrap {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: rgba(41, 144, 255, 0.16);
    border: 1px solid #2990FF;
    border-radius: 4px;
    padding: 8px 0;
    line-height: 22px;
    color: #666666;

    .el-link {
        margin-left: 8px;
    }
}

.select_quotation_wrap {
    height: 600px;

    .flex_wrap {
        gap: 16px;
        margin-bottom: 16px;

        .el-input {
            flex: 1;
        }

        .el-date-editor {
            flex: 1;
        }
    }
}
</style>